;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:cid\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"cid\"],\"hasOptionalPrefix\":false},{\"path\":\"/:cid/:step\",\"regex\":\"^/([^/]+)/([^/]+)$\",\"paramNames\":[\"cid\",\"step\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/agb\"},{\"path\":\"/barrierefreiheit\"},{\"path\":\"/datenschutz\"},{\"path\":\"/impressum\"},{\"path\":\"/nebenkosten-mieter\"},{\"path\":\"/nebenkosten-vermieter\"},{\"path\":\"/schaden\"},{\"path\":\"/so-funktionierts\"},{\"path\":\"/starterkit\"},{\"path\":\"/starterkit-aak\"},{\"path\":\"/werte\"},{\"path\":\"/wissensplattform\"},{\"path\":\"/wissensplattform-aak\"},{\"path\":\"/finished\"},{\"path\":\"/invalid\"},{\"path\":\"/unknown\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';
import posthog from 'posthog-js';

import { beforeSend } from '@/lib/analytics/before-send';
import { POSTHOG_EU_UI_HOST, POSTHOG_PROXY_PATH } from '@/lib/analytics/constants';
import { isAnalyticsEnabled } from '@/lib/analytics/env';
import { hasAnalyticsOptOutFromDocument, hasDoNotTrackEnabled } from '@/lib/analytics/opt-out';

const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

if (isAnalyticsEnabled() && token && !hasAnalyticsOptOutFromDocument() && !hasDoNotTrackEnabled()) {
  posthog.init(token, {
    api_host: POSTHOG_PROXY_PATH,
    ui_host: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST ?? POSTHOG_EU_UI_HOST,
    defaults: '2026-05-30',
    cookieless_mode: 'on_reject',
    person_profiles: 'identified_only',
    respect_dnt: true,
    mask_personal_data_properties: true,
    custom_personal_data_properties: [
      'cid',
      'email',
      'iban',
      'name',
      'phone',
      'phoneNumber',
      'dateOfBirth',
    ],
    disable_capture_url_hashes: true,
    capture_pageview: 'history_change',
    capture_pageleave: true,
    autocapture: false,
    capture_exceptions: false,
    disable_session_recording: true,
    disable_surveys: true,
    capture_heatmaps: false,
    capture_dead_clicks: false,
    advanced_disable_feature_flags: true,
    advanced_disable_feature_flags_on_first_load: true,
    capture_performance: {
      web_vitals: true,
      network_timing: false,
    },
    before_send: beforeSend,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
